import React, { Component } from 'react';
import { Button } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import addToDownloadSite from '../../common/addToDownloadSite';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const monthFormat = 'YYYY-MM';

class Filter extends Component {
    render() {
        const { ...rest } = this.props;
        const filters = [{
            name: '统计时间段',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '人员主管',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 160},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

class ConsumeFteContributeFte extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {
            begin: moment().startOf('year').format(monthFormat),
            end: moment().endOf('year').format(monthFormat),
        },
        curParams: {
            begin: moment().startOf('year').format(monthFormat),
            end: moment().endOf('year').format(monthFormat),
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvUserFteInfo,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                const data = (datas || []).map(item => {
                    const { monthBeanList } = item;
                    (monthBeanList || []).forEach(i => {
                        const { year, month, fte } = i;
                        item[`${year}-${month}`] = fte;
                    });
                    return item;
                })
                this.setState({
                    data,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...params,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.dashboard.exportInvUserFteInfo;
        addToDownloadSite({ ...sortParams, ...curParams }, url, 'Inv_User_Fte_Info');
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const { data } = this.state;
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 80,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 90,
        }, {
            title: '省',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: 80,
        }, {
            title: '市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 90,
        }, {
            title: '直线主管',
            dataIndex: 'leaderUser',
            key: 'leaderUser',
            width: 100,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 160,
        }, {
            title: '科室名称',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            width: 100,
        }, {
            title: 'PI',
            dataIndex: 'piName',
            key: 'piName',
            width: 80,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: '项目分期',
            dataIndex: 'investigationByStageName',
            key: 'investigationByStageName',
            width: 120,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '申办方',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
            width: 120,
        }, {
            title: 'CRO',
            dataIndex: 'croName',
            key: 'croName',
            width: 120,
        }, {
            title: '项目中承担的角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 80,
        }];
        ((data[0] && data[0].monthBeanList) || []).forEach(item => {
            const { year, month, isPlan } = item;
            const yearMonth = `${year}-${month}`;
            columns.push({
                title: `${moment(yearMonth).format(monthFormat)}${isPlan == 1 ? '已分配' : '已确认'}`,
                dataIndex: `${year}-${month}`,
                key: `${year}-${month}`,
                width: 65,
            });
        });
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <TableC
                    data={data}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    className="consumeFteContributeFte"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default ConsumeFteContributeFte;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/consumeFteContributeFte.js